export const incident = {
  table: {
    id: 'ID',
    message: 'メッセージ',
    path: 'パス',
    detail: 'エラーの詳細',
  },
  pageHeader: {
    title: 'エラーの詳細',
  },
}
